import styled, { css } from 'styled-components';
import Typography from '@anwb/typography';
/**
 * Grid title
 */
export const gridTitletyles = () => css `
	margin-bottom: 0;
`;
export const GridContainerTitle = styled(Typography) `
	${gridTitletyles}
`;
//# sourceMappingURL=gridTitle.styled.js.map